module.exports = __webpack_public_path__ + "c6f8973e04ceea0dc8828cc54057ac3b.png";